export const enum Severity {
    error = 'error',
    warning = 'warning',
    info = 'info',
    success = 'success',
}

export type AppBannerSetting = {
    title: string;
    message: string;
    severity: Severity;
    isEnabled: boolean;
};

export type DbMode = 'real' | 'test' | 'prodCopy';

export type DenthubSetting = {
    _id: string;
    labAppBanner: AppBannerSetting;
    clinicAppBanner: AppBannerSetting;
    activeDbMode?: DbMode;
    activeDataSetSnapshotDate?: string;
    authAppBanner: AppBannerSetting;
    emailOtpEnabled?: boolean;
};
